module.exports = __webpack_public_path__ + "static/design-down.84ab58fb.svg";